import GoogleColorful from "@homeinstead/icons/GoogleColorful";
import * as React from "react";
import { cn } from "../utils/classnames";
import { Card, CardContent, CardFooter, CardHeader } from "./Card";

interface ReviewCardProps extends React.HTMLAttributes<HTMLDivElement> {
  avatarClassName?: string;
  name: string;
  initials: string;
  rating: number;
  date: string;
  review: string;
}

const AvatarBackgroundVariants = [
  "bg-[#0098A7]",
  "bg-[#7C5689]",
  "bg-[#849168]",
  "bg-[#289960]",
  "bg-[#BD9270]",
  "bg-[#D35E68]",
] as const;

const ReviewCard = React.forwardRef<HTMLDivElement, ReviewCardProps>(
  (
    {
      className,
      avatarClassName = "bg-[#0098A7]",
      name,
      initials,
      rating,
      date,
      review,
      ...props
    },
    ref,
  ) => (
    <Card
      className={cn(
        "flex max-h-[464px] max-w-80 flex-col rounded-3xl bg-white font-jakarta text-new-beginnings-base shadow-lg",
        className,
      )}
      ref={ref}
      {...props}
    >
      <CardHeader className="flex flex-col items-center pb-2">
        <div className="mb-4 w-full">
          <div
            className={cn(
              "flex h-12 w-12 items-center justify-center rounded-full text-lg text-white",
              avatarClassName,
            )}
          >
            {initials.toLocaleUpperCase()}
          </div>
        </div>
        <div className="w-full">
          <h3 className="font-bold text-base text-new-beginnings-base">
            {name}
          </h3>
          <div className="flex items-center">
            <div className="mr-2 flex">
              {[...Array(Math.round(rating))].map((_, i) => (
                <span className="text-new-beginnings-base" key={i}>
                  ★
                </span>
              ))}
            </div>
            <span className="text-base">{date}</span>
          </div>
        </div>
      </CardHeader>
      <CardContent className="pt-2">
        <p className="line-clamp-5 text-base text-new-beginnings-base leading-relaxed">
          {review}
        </p>
      </CardContent>

      <CardFooter className="mt-auto flex size-6 w-full items-center justify-end px-6">
        <GoogleColorful className="size-6" />
      </CardFooter>
    </Card>
  ),
);
ReviewCard.displayName = "ReviewCard";

export { AvatarBackgroundVariants, ReviewCard };
